import * as rssParser from 'react-native-rss-parser'

const fetchRss = (url) => {
  let retRss = fetch(url, {method: "GET", mode: "cors"})
    .then((response) => response.text())
    .then((responseData) => rssParser.parse(responseData))
    .then((rss) => {
      return rss
    })
  return retRss
}

export {
  fetchRss
}
